module.exports = __webpack_public_path__ + "img/stock6.a717ca39.png";